// tdClient.js
const API_URL = "https://server229256.nazwa.pl/api";

async function apiFetchRaw(path, { method = "GET", token, body, headers } = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers: {
      ...(body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: token } : {}),
      ...(headers || {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(txt || `Request failed: ${res.status}`);
  }
  return res;
}

export async function fetchRiskReport({ nip, token, version = "2.0.0" }) {
  const res = await apiFetchRaw("/td/risk/report", {
    method: "POST",
    token,
    body: { nip, version },
  });
  return res.json(); // { result, version }
}

export async function fetchPrzeswietlReport({ nip, token, version = "2.0.0" }) {
  const res = await apiFetchRaw("/td/przeswietl/report", {
    method: "POST",
    token,
    body: { nip, version },
  });
  return res.json(); // { result, version }
}

export async function fetchRelationsReport({ nip, depth = 2, token, version = "2.0.0" }) {
  const res = await apiFetchRaw("/td/relations/report", {
    method: "POST",
    token,
    body: { nip, depth, version },
  });
  return res.json(); // { result, version }
}
